import { map } from 'rxjs/operators';
import { LogManager } from '../log/log.manager';
import { LogCat } from '../log/log.categories';
import * as i0 from "@angular/core";
import * as i1 from "./assets.proxy";
/**
 ****************************************************************
 * Service class for asset calls.
 *
 * Created by Shai Zelman on 03/05/2020.
 ****************************************************************
 */
var AssetService = /** @class */ (function () {
    function AssetService(assetProxy) {
        this.assetProxy = assetProxy;
    }
    AssetService.prototype.getStaticAssetByCode = function (code) {
        LogManager.debug(LogCat.Asset.Service, "Get static asset by code.", code);
        return this.assetProxy.getStaticAssetByCode(code).pipe(map(function (x) {
            return URL.createObjectURL(x);
        }));
    };
    AssetService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AssetService_Factory() { return new AssetService(i0.ɵɵinject(i1.AssetsProxy)); }, token: AssetService, providedIn: "root" });
    return AssetService;
}());
export { AssetService };
